export default __webpack_public_path__ + "static/media/feature3.a37b5bd6.svg";